"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassportStorage = void 0;
const __1 = require("../..");
class PassportStorage {
    constructor(arcxLogger, passportsCollection) {
        this.arcxLogger = arcxLogger;
        this.passportsCollection = passportsCollection;
    }
    readPassport(chainId, address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const passport = (yield this.passportsCollection[(0, __1.getNetworkGroup)(chainId)].findOne({
                    address: address.toLowerCase(),
                }));
                return passport;
            }
            catch (error) {
                this.arcxLogger.warning(`PassportStorage::readPassport => Could not find passport for ${address} on chain ${chainId}: ${error}`);
                return undefined;
            }
        });
    }
    readPassports(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const passports = (yield this.passportsCollection[(0, __1.getNetworkGroup)(chainId)]
                    .find()
                    .toArray());
                return passports;
            }
            catch (error) {
                this.arcxLogger.warning(`PassportStorage::readPassports => Could not find passports on chain: ${chainId}: ${error}`);
                return [];
            }
        });
    }
    readDistinctPassportHolders(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.passportsCollection[(0, __1.getNetworkGroup)(chainId)]
                    .aggregate([
                    {
                        $group: {
                            _id: '$address',
                            date_claimed: {
                                $addToSet: '$date_claimed',
                            },
                        },
                    },
                    {
                        $project: {
                            _id: 0,
                            address: '$_id',
                            date_claimed: {
                                $toLong: {
                                    $arrayElemAt: ['$date_claimed', 0],
                                },
                            },
                        },
                    },
                ])
                    .toArray();
            }
            catch (error) {
                this.arcxLogger.warning(`PassportStorage::readDistinctPassportHolders => Could not fetch passport holders: ${error}`);
                return [];
            }
        });
    }
    readPassportCount(chainId, humanOnly = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const query = humanOnly ? { 'stats.isHuman': true } : {};
                return this.passportsCollection[(0, __1.getNetworkGroup)(chainId)].countDocuments(query);
            }
            catch (error) {
                this.arcxLogger.warning(`PassportStorage::readPassportCount => Could not fetch passport count: ${error}`);
                return 0;
            }
        });
    }
    createOrUpdatePassports(chainId, newPassports) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (newPassports.length === 0)
                    return;
                yield this.passportsCollection[(0, __1.getNetworkGroup)(chainId)].bulkWrite(newPassports.map((passport) => {
                    var _a;
                    delete passport._id; // _id is imutable, so we need to strip it
                    return {
                        updateOne: {
                            filter: { address: (_a = passport.address) === null || _a === void 0 ? void 0 : _a.toLowerCase() },
                            update: { $set: passport },
                            upsert: true,
                        },
                    };
                }));
            }
            catch (error) {
                this.arcxLogger.error(`PassportStorage::createOrUpdatePassports => Could not upsert passports:${error}`);
            }
        });
    }
}
exports.PassportStorage = PassportStorage;
//# sourceMappingURL=PassportStorage.js.map